import React from 'react';
import {
  getPrettyPlanCarrier,
  getSubStatus,
  needToShowPlanCarrier,
} from 'helpers/subs';
import { Link } from 'react-router-dom';
import { splitLongText } from 'helpers/text';
import { isB2b, isResold } from 'helpers/user';

const UserSubList = ({
  subs,
  user,
  userId,
  heading,
  viewUrl,
  tabButtons = null,
  NewUserSubLink,
  carrier,
}) => {
  const isSimo = carrier === 'simo';
  const showAddSub =
    (!isSimo || (isSimo && (isB2b(user) || isResold(user)))) &&
    user?.is_active &&
    NewUserSubLink;
  const isQuick = carrier === 'quick';

  return (
    <div>
      <div className="d-flex-vc mar-t" style={{ marginBottom: '10px' }}>
        <h3 style={{ marginTop: 0, marginBottom: 0 }}>{heading}</h3>
        <div className="mar-l">
          {showAddSub && <NewUserSubLink user={user} />}
        </div>
      </div>
      {tabButtons}
      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>{isSimo ? 'Device SN' : 'MDN'}</th>
            <th>Status</th>
            <th>{isSimo ? 'Device Type' : isQuick ? 'Vendor' : 'Platform'}</th>
            {isQuick && <th>Network</th>}
            <th>Plan</th>
            {!isQuick && <th>Agent</th>}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {subs.length > 0 ? (
            subs.map((sub) => {
              return (
                <tr key={sub.id}>
                  <td>{sub.id}</td>
                  <td>{splitLongText(sub.first_name)}</td>
                  <td>{splitLongText(sub.last_name)}</td>
                  <td>{isSimo ? sub.device_sn : sub.mdn}</td>
                  <td>{getSubStatus(sub)}</td>
                  <td>
                    {isSimo
                      ? sub.device_type_name
                      : isQuick
                        ? sub.vendor
                        : sub.platform}
                  </td>
                  {isQuick && <td>{sub?.plan?.network}</td>}
                  <td>
                    {needToShowPlanCarrier(sub, sub?.plan?.plan_carrier) && (
                      <span>
                        {getPrettyPlanCarrier(sub?.plan?.plan_carrier)}
                      </span>
                    )}{' '}
                    {sub.plan && sub.plan.name}
                  </td>
                  {!isQuick && (
                    <td>{sub.agent_name && sub.agent_name.split(' ')[0]}</td>
                  )}
                  <td>
                    <Link to={viewUrl(sub)}>Details</Link>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td>No subscriptions yet</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserSubList;
